/**
 * 商户在库记录
 */
import React from "react";

import { Modal, Tooltip,Button } from "antd";

import PageLayout from "../../ui/PageLayout";

import http from '../../../axios/http';

class MemberCouponDetail extends React.Component {
  columns = [
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: 100,
    },
    {
      title: "操作人",
      dataIndex: "couponUser",
      width: 100,
    },
    {
      title: "优惠券生效日",
      dataIndex: "couponAvailDate",
      width: 100,
    },
    {
      title: "备注",
      dataIndex: "couponMemo",
      width: 200,
    },
    {
      title: "状态",
      dataIndex: "couponState",
      width: 100,
      format: {
        Avail: "可用",
        Expired: "已作废",
        Used: "已使用",
      },
    },
    {
      title: "抵扣时长",
      dataIndex: "couponHour",
      render: (text, record, index) => (
        <Tooltip title={this.getCouponStr(record)}>{record.couponHour}</Tooltip>
      ),
      width: 100,
    },
  ];
  getCouponStr = (record) => {
    if (record.couponHour)
      return (
        <div>
          <div>入场时间: {record.inTime}</div>
          <div>出场时间: {record.outTime}</div>
        </div>
      );
    else return "";
  };
  state = {
    loadData: "",
    queryData: {
      memberCode: "",
    },
    memberName: "",
  };

  componentWillReceiveProps(nextProp) {
    var { memberCode, month } = nextProp;
    let queryData = this.state.queryData;
    queryData.memberCode = memberCode;
    queryData.month = month;
    this.setState({ queryData });
    if (this.state.loadData) this.state.loadData(queryData);
  }

  downLoad=()=>{
    let queryData = this.props;
    //this.setState({ loadingVisible: true });
    http.download({
        url: '/barrier/download/memberCouponList',
        data: queryData,
        fileName: "账单信息.xlsx",
        success: (res) => {
            //this.setState({ loadingVisible: false });
        },
        error: (res) => {
            //this.setState({ loadingVisible: false });
        }
    });
  }

  render() {
    const { visible, memberName, memberCode, onCancel, month } = this.props;
    return (
      <Modal
        width={1000}
        visible={visible}
        title={memberName + "优惠券明细"}
        okText="确定"
        cancelText="取消"
        onOk={this.onCancel}
        onCancel={onCancel}
        footer={[
          <Button key="cancel" type="primary" onClick={this.downLoad}>下载</Button>
          ]
        }
      >
        <div style={{ width: "100%", height: "500px" }}>
          <PageLayout
            rowKey="tableKey"
            url="/barrier/getMemberCouponListEx"
            columns={this.columns}
            initParams={{ memberCode, month }}
            loadData={(func) => {
              this.setState({
                loadData: func,
              });
            }}
          />
        </div>
      </Modal>
    );
  }
}

export default MemberCouponDetail;
